import React 					from  	'react';

function getCurrentState( props ) {


	return {	

		col 		: 	props.col,
		row 		: 	props.rowIndex,
		data 		: 	props.data
	}
}

var GoogleSearchCell = React.createClass({

	getInitialState : function() {

		let currentState 		= getCurrentState( this.props );

		return currentState;
	},

	componentWillReceiveProps : function( newProps ) {

		this.setState( getCurrentState( newProps ) );
	},

	shouldComponentUpdate : function( nextProps, nextState ) {

		return true;
	},

	render : function() {

		const display 	= this.state.data.getObjectAt( this.state.row )[this.state.col];

		const url 		= "http://www.google.co.uk/search?q=" + display;

		return (

			<div>
				<a target="_blank" href={url}>{display}</a>
			</div>
		);
	}
});

export default GoogleSearchCell;


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/DataTables/GoogleSearchCell.react.js